import { Authenticator, translations } from '@aws-amplify/ui-react';
import { Auth, I18n } from 'aws-amplify';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import type { RootState } from '@/app/store';
import { Drawer } from '@/components/Elements/Drawer/Drawer';
import { HeadBlock } from '@/components/Elements/HeadBlock/HeadBlock';
import { getLocationPath } from '@/utils/getLocationPath';
import { useMapParams } from '@/utils/useMapParams';

// バックエンドからのエラーメッセージは英語表記になる。このエラー処理関数は上書きできない。

I18n.putVocabularies(translations);
I18n.setLanguage('ja');

interface FormData {
  username: string;
  password: string;
}

export function AdminSignIn() {
  const { headerHeight } = useSelector((state: RootState) => state.drawer);
  const { currentLocation, zoom } = useSelector(
    (state: RootState) => state.map
  );
  const { mapType } = useMapParams();
  const title = useRef('');
  title.current = '管理者マップにサインイン';

  const navigate = useNavigate();

  const components = {
    SignIn: {
      Footer() {
        // NOTE: 「パスワードをお忘れの方」リンクを非表示にする
        return null;
      },
    },
  };

  const services = {
    async handleSignIn(formData: FormData) {
      const { username, password } = formData;

      return await Auth.signIn({
        username,
        password,
      });
    },
  };

  const formFields = {
    signIn: {
      username: {
        labelHidden: false,
        label: 'メールアドレスまたはユーザー名',
        isRequired: true,
        placeholder: '',
        'data-testid': 'sign-in-username-input',
      },
      password: {
        labelHidden: false,
        isRequired: true,
        placeholder: '',
        'data-testid': 'sign-in-password-input',
      },
    },
  };

  return (
    <>
      <HeadBlock title={title.current} />
      <Drawer
        title={title.current}
        isOpen
        width="608px"
        isCloseButton
        closeDrawer={() => {
          const path = getLocationPath(
            currentLocation.latitude,
            currentLocation.longitude,
            zoom,
            '/',
            mapType
          );
          navigate(`${path}${location.search}`);
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            height: `calc(100% - ${headerHeight}px)`,
          }}
        >
          <Authenticator
            components={components}
            formFields={formFields}
            hideSignUp={true}
            loginMechanisms={['username', 'email']}
            services={services}
          />
        </div>
      </Drawer>
    </>
  );
}
